module.exports = __webpack_public_path__ + "static/media/QuickShopImageNew.d043b201.png";